module.exports = {
    WEEK: 'week',
    MONTH: 'month',
};
